module.exports = __webpack_public_path__ + "media/img/sbt-test/Scholarships2u-Student-Search-e63f52e951eb5b79974e6bfb3c47ec79.svg";